import Swal from 'sweetalert2';

const API_BASE = process.env.REACT_APP_API_BASE;

//export const logout = async () => { 
export const logout = () => {
  // Limpiar todos los tokens y datos de sesión
  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  
  // Llamar al servidor para invalidar la cookie
  /* try {
    await fetch(`${API_BASE}/logout`, {
      method: 'POST',
      credentials: 'include'
    });
  } catch (err) {
    console.log('Error en logout del servidor:', err);
  } */

  // Llamar al servidor sin await (fire and forget)
  fetch(`${API_BASE}/logout`, {
    method: 'POST',
    credentials: 'include'
  }).catch(err => console.log('Error en logout:', err));


  // Limpiar contexto y redirigir
  /* GConText.setUserId('');
  GConText.setNombre('');
  GConText.setGrupo('');
  GConText.setType('');
 */
  // Redirigir al login
  window.location.href = '/';
  
};


// Función alternativa que no necesita contexto
export const logoutSimple = () => {
  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  
  fetch(`${API_BASE}/logout`, {
    method: 'POST',
    credentials: 'include'
  }).catch(err => console.log('Error en logout:', err));

  window.location.href = '/';
};

// Logout con mensaje visible al usuario (evita múltiples ejecuciones)
let _logoutTriggered = false;
export const logoutWithMessage = () => {
  if (_logoutTriggered) return;
  _logoutTriggered = true;

  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');

  fetch(`${API_BASE}/logout`, {
    method: 'POST',
    credentials: 'include'
  }).catch(() => {});

  Swal.fire({ title: 'Sesión expirada', text: 'Tu sesión ha expirado. Inicia sesión nuevamente.', icon: 'info', confirmButtonText: 'Aceptar' }).then(() => {
    window.location.href = '/';
  });
};